import { CreateRenderFunction } from "@pdfking/reactivity/preact"

export default CreateRenderFunction({
  data: {},
  render() {
    return null
  },
})
